import React, { useState, useEffect } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { Link } from "react-router-dom";
import { Footer } from "../../components/SpearParts/Layouts/Footer";
import Axios from "../../axios/axios";
import { toTitleCase } from "../../components/utils/StringUtil";
import AlertModal from "../../actions/AlertModal";
import TopNavBar from "../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../components/SpearParts/Layouts/TopSearchBar";

export default function PurchaseHistory() {
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [returnData, setReturnData] = useState({
    description: "",
    image: null,
  });
  const [selectedItem, setSelectedItem] = useState(null);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const customerId = userInfo?.customerId;

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    fetchCompletedOrders();
  }, []);

  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        setShowSuccessModal(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessModal]);

  const fetchCompletedOrders = async () => {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const customerId = userInfo?.customerId;
    const businessType = sessionStorage.getItem("businessType");

    if (!customerId || !businessType) return;

    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_API_URL}orders/delivered/${customerId}`
      );
      console.log("API Response Orders:", response.data);

      const allOrders = response.data || [];

      const filteredOrders = allOrders.filter((order) =>
        order.orderItems.some((item) =>
          item.productType?.some(
            (pt) => pt.toLowerCase() === businessType.toLowerCase()
          )
        )
      );

      const sortedOrders = [...filteredOrders].sort((a, b) => {
        const aTime = a.orderDate
          ? new Date(a.orderDate).getTime()
          : parseInt(a._id.toString().substring(0, 8), 16) * 1000;

        const bTime = b.orderDate
          ? new Date(b.orderDate).getTime()
          : parseInt(b._id.toString().substring(0, 8), 16) * 1000;

        return bTime - aTime;
      });

      setOrders(sortedOrders);
    } catch (error) {
      console.error("API Error:", {
        message: error.message,
        url: error.config?.url,
        response: error.response?.data,
      });
    }
  };
  const openReturnModal = async (item, order) => {
    let productId = item.productId;

    if (!productId) {
      const matchingItem = order.orderItems.find(
        (oi) => oi.productName === item.productName
      );
      productId = matchingItem?.productId || null;
    }

    setSelectedItem({
      ...item,
      productId,
      orderId: order._id,
      customerId,
    });

    // ✅ Reset return data every time modal is opened
    setReturnData({ description: "", image: null });

    setShowModal(true);
  };

  const handleSubmitReturn = async () => {
    if (!returnData.description) {
      alert("Reason for return is required.");
      return;
    }

    const formData = new FormData();
    formData.append("description", returnData.description);
    if (returnData.image) {
      formData.append("image", returnData.image);
    }

    formData.append("customerId", selectedItem.customerId);
    formData.append("productId", selectedItem.productId);

    formData.append("name", selectedItem.productName);
    formData.append("orderId", selectedItem.orderId);

    try {
      await Axios.post(`${process.env.REACT_APP_API_URL}returns`, formData);
      setShowModal(false);
      setShowSuccessModal(true);

      fetchCompletedOrders();
    } catch (err) {
      console.error(err);
      alert("Error submitting return.");
    }
  };
  const handleCloseModal = () => {
    setReturnData({ description: "", image: null });
    setSelectedItem(null);
    setShowModal(false);
  };

  const calculateSubtotal = (orderItems) => {
    return orderItems.reduce(
      (sum, item) => sum + (item.customerTotalPerItem || 0),
      0
    );
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  return (
    <div style={sectionStyle}>
      {/* <Header /> */}
      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
       <section class="purchaseHistory" className="order-section-main">
          <div class="container">
            <div class="mt-3 result-select">
              <div className="col-lg-12 purchase-spacing">
                <p class="movePages">
                  {" "}
                  <img src="/images/backIcon.svg" />{" "}
                  <Link to="/account" class="account">
                    {" "}
                    Account{" "}
                  </Link>{" "}
                  <a href="#"> Purchase history </a>{" "}
                </p>
                <div class="row no-gutters purchaseHisOptions">
                  <div class="col-lg-6">
                    <h4 class="text-uppercase"> Purchase History</h4>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-row order-search">
                      <div class="col-lg-3 my-auto column-4 col-12 offset-lg-4">
                        {/* <a href="soa.html" class="a-action"><span>SOA</span></a> */}
                      </div>
                      <div class="col-lg-2 my-auto column-3 col-6">
                        {/* <a href="#">Filter &nbsp;&nbsp;<img src="/images/filter.png"/> </a> */}
                      </div>
                      <div class="col-lg-3 my-auto column-4 col-6">
                        <a
                          href="#"
                          class="export"
                          style={{ textDecoration: "none" }}
                        >
                          <span>
                            Export as PDF &nbsp;&nbsp;
                            <img src="/images/pdf.png" />
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {orders.length > 0 ? (
                  orders.map((order) => (
                    <div key={order._id}>
                      <div className="historyHeading">
                        <div className="row">
                          <div className="col-md-4">
                            <p>
                              Purchase ID: <b>#{order._id}</b>
                            </p>
                          </div>
                          <div className="col-md-5">
                            <p className="orderDate">
                              Ordered on{" "}
                              {new Date(order.orderDate).toDateString()}
                            </p>
                          </div>
                          <div className="col-md-3">
                            <a href="#" className="btn taxInvoiceBtn">
                              <span>Tax Invoice</span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="historyContent">
                        <div className="row">
                          <div className="col-md-6">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Items</th>
                                </tr>
                              </thead>
                              <tbody>
                                {order.orderItems.map((item) => (
                                  <tr key={item._id}>
                                    <td>{toTitleCase(item.productName)}</td>
                                    <td>Qty: {item.quantity}</td>
                                    <td>
                                      {order.currency}{" "}
                                      {item.customerTotalPerItem}
                                    </td>

                                    <td>
                                      {item.isReturned ? (
                                        <button
                                          className="btn btn-secondary btn-sm"
                                          disabled
                                          style={{
                                            fontSize: "0.7rem",
                                            padding: "2px 6px",
                                          }}
                                        >
                                          Returned
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() =>
                                            openReturnModal(
                                              {
                                                ...item,
                                                supplierId: item.supplierId,
                                              },
                                              order
                                            )
                                          }
                                          style={{
                                            fontSize: "0.7rem",
                                            padding: "2px 6px",
                                          }}
                                        >
                                          Return
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-md-5 orderSummary">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Order summary</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(() => {
                                  const calculatedSubTotal =
                                    order.orderItems.reduce(
                                      (acc, item) =>
                                        acc + (item.customerTotalPerItem || 0),
                                      0
                                    );
                                  return (
                                    <tr>
                                      <td>Sub total</td>
                                      <td>
                                        {order.currency}{" "}
                                        {calculatedSubTotal.toFixed(2)}
                                      </td>
                                    </tr>
                                  );
                                })()}

                                <tr>
                                  <td>Payment Status</td>
                                  <td>{order.paymentStatus}</td>
                                </tr>
                                <tr>
                                  <td>Total</td>
                                  <td>
                                    {order.currency}{" "}
                                    {order.customerTotal?.toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-8 deliveryAddress">
                          <h6>Delivery address</h6>
                          <p>
                            {toTitleCase(order.customer.customerName)}
                            <br />
                            {order.customer.email}
                            <br />
                            {order.customer.phoneNumber}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No purchase history found.</p>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      {showModal && (
        <div className="modal show fade" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Return Product</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <label>Reason for return *</label>
                <textarea
                  className="form-control mb-2"
                  onChange={(e) =>
                    setReturnData({
                      ...returnData,
                      description: e.target.value,
                    })
                  }
                  required
                />
                <label>Upload image *</label>
                <input
                  key={showModal ? "input-reset" : "input"}
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) =>
                    setReturnData({ ...returnData, image: e.target.files[0] })
                  }
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSubmitReturn}
                >
                  Submit Return
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <AlertModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        message="Your return was submitted. Admin will contact you soon."
      />
      {/* 
      <Footer /> */}
    </div>
  );
}
